import { createSelector } from 'reselect';
import { LensAddOnVariantStepContainer } from '../../../../Configurator/steps/LensAddOnVariantStep/LensAddOnVariantStepContainer.js';
import { getSelectedAddOn } from '../../selectors.js';

const lensAddOnVariantStep = {
    stepStatus: createSelector(getSelectedAddOn, (selectedAddOn)=>{
        var ref;
        return Number(selectedAddOn === null || selectedAddOn === void 0 ? void 0 : (ref = selectedAddOn.variants) === null || ref === void 0 ? void 0 : ref.length) > 1 ? 'sub-step' : 'hidden';
    }),
    view: LensAddOnVariantStepContainer
};

export { lensAddOnVariantStep };
//# sourceMappingURL=lens-add-on-variant.js.map
